export default "__VITE_ASSET__B4$fNJlf__"